import { MagicConfigMixin, ImageFormat, getImagePath, ImageType, cdnService } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { CtaStyle } from '@gig/magic-sdk';
import { PromotionsOptinMixin } from '../../mixins/promotions-optin.mixin.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let PromotionCardComponent = class extends Mixins(MagicConfigMixin, PromotionsOptinMixin) {
  get src() {
    return this.getImage(ImageFormat.WEBP);
  }
  get avifSrcset() {
    return this.getImageSrcset(ImageFormat.AVIF);
  }
  get webpSrcset() {
    return this.getImageSrcset(ImageFormat.WEBP);
  }
  get ctas() {
    if (!this.promotion) {
      return [];
    }
    return this.promotion.values.cta;
  }
  get showOptIn() {
    return this.optIns.length === 1;
  }
  get optIns() {
    return this.ctas.filter(({ style }) => style === CtaStyle.OPTIN);
  }
  get linkCtas() {
    return this.ctas.filter(({ style }) => style === CtaStyle.LINK);
  }
  get hasOptedIn() {
    if (!this.showOptIn) {
      return false;
    }
    if (!this.isLoggedIn || !this.optIns[0].roles) {
      return false;
    }
    return this.optIns[0].roles.every((role) => this.userRoles.includes(role));
  }
  onCtaClick(cta, event) {
    var _a;
    if (!this.isOptIn(cta) || this.hasOptedIn) {
      return;
    }
    event.preventDefault();
    this.optIn((_a = this.promotion) == null ? void 0 : _a.name, cta);
  }
  getImageSrcset(format) {
    return `${this.getImage(format)}, ${this.getImage(format, true)} 2x`;
  }
  getImage(format, retina = false) {
    if (!this.promotion || !this.promotion.image) {
      return null;
    }
    const promotionImage = getImagePath(ImageType.PROMO_IMAGES, this.promotion.image);
    return cdnService.getImageUrl(promotionImage, {
      width: this.imageWidth,
      quality: 100,
      retina,
      format
    });
  }
};
__decorateClass([
  Prop({ type: Object, default: () => ({}) })
], PromotionCardComponent.prototype, "promotion", 2);
__decorateClass([
  Prop(String)
], PromotionCardComponent.prototype, "tag", 2);
__decorateClass([
  Prop({ type: Number, default: 380 })
], PromotionCardComponent.prototype, "imageWidth", 2);
PromotionCardComponent = __decorateClass([
  Component({
    name: "promotion-card"
  })
], PromotionCardComponent);

export default PromotionCardComponent;
